import './RoleSelectionDialog.css';
import { useTranslation } from 'react-i18next';

const RoleCard = ({ data, handleSelectRole, isSelected, isDisabled }) => {
    const { t } = useTranslation();
    const roleName = data?.roleName || data?.RoleName;
    const functionName = data?.functionName || data?.FunctionName;
    const orgName = data?.orgName || data?.OrgName;
    const isLocked = isSelected || isDisabled;
    const translatedRoleName = roleName ? t(roleName, roleName) : '';
    const translatedFunctionName = functionName ? t(functionName, functionName) : '';

    return (
        <div
            disabled={isLocked}
            aria-disabled={isLocked}
            className={`role-card-container ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
            onClick={isLocked ? () => {} : () => handleSelectRole()}
        >
            <div className="role-card-title">
                {isSelected ? `${translatedRoleName} (${t('Selected', 'Selected')})` : translatedRoleName}
            </div>
            <div className="role-card-detail">{translatedFunctionName}</div>
            <div className="role-card-status">{orgName}</div>
        </div>
    );
};

export default RoleCard;
